import { Environment } from '../env/Environment';
import { Typography } from './primitives';
import { useTranslation } from '@rpi/i18n';
import clsx from 'clsx';
import React from 'react';

type FooterLinkProps = { href: string; label: string };

const FooterLink: React.FC<FooterLinkProps> = ({ href, label }) => {
  return (
    <Typography
      as="a"
      variant="footer"
      className="no-underline text-inherit flex"
      href={href}
      aria-label={label}
      title={label}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </Typography>
  );
};

export const Footer: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.footer' });
  const currYear = new Date().getFullYear();

  return (
    <div
      className={clsx(
        'px-4 md:px-10 py-4 w-full flex justify-center md:justify-start items-center gap-7 flex-wrap',
        className,
      )}
    >
      <Typography variant="footer">{`© 2015-${currYear} RPI Print, Inc.`}</Typography>
      <FooterLink
        href={Environment.LINK.BLURB_SHIPPING}
        label={t('shipping')}
      />
      <FooterLink href={Environment.LINK.BLURB_TAXES} label={t('taxes')} />
      <FooterLink href={Environment.LINK.BLURB_RETURNS} label={t('returns')} />
      <FooterLink
        href={Environment.LINK.BLURB_PRIVACY}
        label={t('privacy_policy')}
      />
      <FooterLink
        href={Environment.LINK.BLURB_TERMS}
        label={t('terms_and_conditions')}
      />
    </div>
  );
};
